import { call, put, select } from 'redux-saga/effects'
import { makeAccess } from '../../../../../config/factory-controller'
import type { ApiResponse } from '../../../../../config/api-types'
import type { CreateCollectionOrderRequest } from '../../../domain/models/create-collection-order'
import type { RootState } from '../../../../../redux/global-store'
import { CreateCollectionOrderService } from '../../../service/create-collection-order-service'
import { apiConfig } from '../../../../../config/api-config'
import { CreateCollectionOrderRepository } from '../../../data/repositories/create-collection-order-repository'
import { CreateCollectionOrderController } from '../../controllers/create-collection-order-controller'
import * as action from '../actions/create-collection-order-actions'
import { getJourneyRequest } from '../../../../journey/presentation/redux/actions/journey-actions'

export const controller = async (payload: CreateCollectionOrderRequest) => {
  const { key, token } = await makeAccess()
  const dataSource = new CreateCollectionOrderService(apiConfig(key, token))
  const repository = new CreateCollectionOrderRepository(dataSource)
  const control = new CreateCollectionOrderController(repository)
  return await control.create(payload)
}

export function* createCollectionOrderSaga({ payload }: any): any {
  try {
    const result: ApiResponse = yield call(controller, payload)
    yield put(action.createCollectionOrderSuccess(result))
    
    // Após criar CollectionOrder com sucesso, atualizar "Tus ventas hoy" fazendo GetJourney
    const userState = yield select((state: RootState) => state.auth.login.user)
    if (userState?.userId) {
      console.log('CollectionOrder created successfully, updating daily sales via GetJourney...')
      yield put(getJourneyRequest({ userId: userState.userId }))
    }
  } catch (error: any) {
    yield put(action.createCollectionOrderError(error.toString()))
  }
}
